module.exports = __webpack_public_path__ + "media/failed2.a15d461e.ogg";